import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Spinner, Badge } from 'react-bootstrap';
import HeaderNav from "../../../Budget/Budget Dashboard/HeaderNav/HeaderNav";
import axios from "axios";
import { BASE_URL } from "../../../../Components/Styles/API/API";
import { useNavigate } from "react-router-dom";
import MailLogo from "../../../../Assets/mail.svg";
import PrintLogo from "../../../../Assets/print.svg";
import ExcelLogo from "../../../../Assets/excel.png";
import PdfLogo from "../../../../Assets/pdf.png";
import BackLogo from "../../../../Assets/back.svg";
import RotatingLogo from '../../../../Assets/rotating-logo.png';

import classes from "./ProvinceStatus.module.css";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import jsPDF from "jspdf";
import "jspdf-autotable";
import Swal from "sweetalert2";


const ProvinceStatus = () => {
  const navigate = useNavigate();

  // State declarations
  const [bearer, setBearer] = useState('');
  const [loading, setLoading] = useState(false);
  const [selectedContinent, setSelectedContinent] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('');
  const [continents, setContinents] = useState([]);
  const [regions, setRegions] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage] = useState(50);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
    const [isSaving, setIsSaving] = useState(false);
  const [isSaving1, setIsSaving1] = useState(false);

  // Read authentication data
  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      if (value !== null) {
        setBearer(value);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  // Fetch all provinces with last date by default (paginated)
  const fetchProvincesWithLastDate = async (page = 1, continentId = '', regionId = '') => {
    setLoading(true);
    try {
      const params = {
        page: page,
        per_page: entriesPerPage
      };

      if (continentId) params.continent_id = continentId;
      if (regionId) params.region_id = regionId;

      const response = await axios.get(`${BASE_URL}/provinces/province_with_lastdate`, {
        params,
        headers
      });

      const provincesData = response.data?.data?.data || [];
      const paginationInfo = response.data?.data || {};

      setProvinces(provincesData);
      setTotalPages(paginationInfo.last_page || 1);
      setTotalEntries(paginationInfo.total || 0);
      setCurrentPage(paginationInfo.current_page || 1);

    } catch (error) {
      console.error('Error fetching provinces:', error);
      setProvinces([]);
      setTotalPages(1);
      setTotalEntries(0);
    } finally {
      setLoading(false);
    }
  };

  // Fetch continents
  const fetchContinents = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/continents`, { headers });
      const results = response.data?.data || [];

      const options = results.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setContinents(options);
    } catch (error) {
      console.error('Error fetching continents:', error);
      setContinents([]);
    }
  };

  // Fetch regions for selected continent
  const fetchRegions = async (continentId) => {
    if (!continentId) {
      setRegions([]);
      setSelectedRegion('');
      return;
    }

    try {
      const response = await axios.get(`${BASE_URL}/continents/getcontinentregions?continent_id=${continentId}`, { headers });
      const results = response.data?.data || [];

      const options = results.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setRegions(options);
    } catch (error) {
      console.error('Error fetching regions:', error);
      setRegions([]);
    }
  };

  // Handle continent change
  const handleContinentChange = (selectedOption) => {
    const continentId = selectedOption?.value || '';
    setSelectedContinent(continentId);
    setSelectedRegion('');
    setRegions([]);

    // Fetch regions for the selected continent
    if (continentId) {
      fetchRegions(continentId);
    }

    // Reset to page 1 and filter provinces
    setCurrentPage(1);
    fetchProvincesWithLastDate(1, continentId, '');
  };

  // Handle region change
  const handleRegionChange = (selectedOption) => {
    const regionId = selectedOption?.value || '';
    setSelectedRegion(regionId);

    // Reset to page 1 and filter provinces with both continent and region
    setCurrentPage(1);
    fetchProvincesWithLastDate(1, selectedContinent, regionId);
  };

  // Handle page change
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchProvincesWithLastDate(newPage, selectedContinent, selectedRegion);
  };

  // Format text with ellipsis for long words
  const formatTextWithEllipsis = (text) => {
    if (!text) return 'N/A';
    if (text.length > 12) {
      return text.substring(0, 15) + '...';
    }
    return text;
  };

  // Initial data fetching
  useEffect(() => {
    if (bearer) {
      fetchContinents();
      fetchProvincesWithLastDate(1); // Fetch all provinces by default
    }
  }, [bearer]);

  // Export functions
  const exportToExcel = () => {
    if (!provinces || provinces.length === 0) {
      console.log("No data available to export");
      return;
    }

    const excelRows = [
      ["PROVINCE STATUS REPORT"],
      [],
      ["S/N", "PROVINCE NAME", "REGION","CONTINENT", "LAST DATE", "STATUS"]
    ];

    provinces.forEach((province, index) => {
      const statusText =
        province.status === 1 ? "Updated" :
          province.status === 2 ? "Behind Schedule" : "Outdated";

      excelRows.push([
        index + 1,
        province.description || province.name || 'N/A',
        province.region?.description || 'N/A',
        province.continent?.description || 'N/A',
        province.last_date ? new Date(province.last_date).toLocaleDateString() : 'N/A',
        statusText,
      ]);
    });

    const worksheet = XLSX.utils.aoa_to_sheet(excelRows);
    worksheet["!cols"] = [
      { wch: 10 }, // S/N
      { wch: 40 }, // PROVINCE
      { wch: 30 }, // REGION
      { wch: 30 }, // CONTINENT
      { wch: 20 }, // LAST DATE
      { wch: 20 }, // STATUS
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Province Status Report");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "ProvinceStatusReport.xlsx");
  };

  const ExcelDownload = async () => {
  setIsSaving(true);
  setIsSaving1(true);

  try {
    // const payload = {
    //   province_id: provinceID,
    //   receipt_type: selectedPaymentType,
    //   payment_mode: typePayment,
    //   start_date: startDate,
    //   end_date: endDate,
    // };

    const token = localStorage.getItem("userToken");

    const response = await axios.get(
      `${BASE_URL}/download_province_status_excel`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        // params: payload,
        responseType: "blob", // ⭐ CRITICAL
      }
    );

    // 🧠 Create file blob
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // 🧠 Create temporary link
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "Province_Status_Report.xlsx"; // set filename here
    document.body.appendChild(link);
    link.click();

    // 🧹 Cleanup
    link.remove();
    window.URL.revokeObjectURL(url);

    Swal.fire({
      icon: "success",
      title: "Download Complete",
    });

    // handleCloseDown();
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Failed to download file.",
    });
  } finally {
    setIsSaving(false);
    setIsSaving1(false);
  }
};

  const exportToPDF = () => {
    if (!provinces || provinces.length === 0) {
      console.log("No data available to export");
      return;
    }

    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();

    // Header
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text("The Redeemed Christian Church Of God", pageWidth / 2, 15, { align: "center" });

    doc.setFont("helvetica", "normal");
    doc.setFontSize(14);
    doc.text("Province Status Report", pageWidth / 2, 25, { align: "center" });

    // Add filter info if any
    if (selectedContinent || selectedRegion) {
      doc.setFontSize(10);
      let filterText = "Filtered by: ";
      if (selectedContinent) {
        const continent = continents.find(c => c.value === selectedContinent);
        filterText += `Continent: ${continent?.label || ''}`;
      }
      if (selectedRegion) {
        const region = regions.find(r => r.value === selectedRegion);
        filterText += selectedContinent ? `, Region: ${region?.label || ''}` : `Region: ${region?.label || ''}`;
      }
      doc.text(filterText, pageWidth / 2, 32, { align: "center" });
    }

    // Table data
    const tableData = provinces.map((province, index) => {
      const statusText =
        province.status === 1 ? "Updated" :
          province.status === 2 ? "Behind Schedule" : "Outdated";

      return [
        index + 1,
        province.description || province.name || 'N/A',
        province.region?.description || 'N/A',
        province.continent?.description || 'N/A',
        province.last_date ? new Date(province.last_date).toLocaleDateString() : 'N/A',
        statusText,
      ];
    });

    // AutoTable
    doc.autoTable({
      head: [['S/N', 'PROVINCE NAME', 'REGION', 'CONTINENT','LAST DATE', 'STATUS']],
      body: tableData,
      startY: selectedContinent || selectedRegion ? 38 : 35,
      styles: { fontSize: 9, cellPadding: 3 },
      headStyles: { fillColor: [0, 51, 102], textColor: 255, fontSize: 10 },
      alternateRowStyles: { fillColor: [245, 245, 245] },
      columnStyles: {
        0: { cellWidth: 15 }, // S/N
        1: { cellWidth: 50 }, // PROVINCE
        2: { cellWidth: 40 }, // REGION
        3: { cellWidth: 40 }, // CONTINENT
        4: { cellWidth: 30 }, // LAST DATE
        5: { cellWidth: 25 }, // STATUS
      },
    });

    doc.save("ProvinceStatusReport.pdf");
  };

  const handlePrint = () => {
    window.print();
  };

  // Format date function
  function formatDate(dateString) {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }

  // Calculate serial number based on current page
  const getSerialNumber = (index) => {
    return (currentPage - 1) * entriesPerPage + index + 1;
  };

  // Generate pagination buttons
  const renderPaginationButtons = () => {
    const buttons = [];
    const maxVisiblePages = 5;

    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    // Previous button
    buttons.push(
      <button
        key="prev"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={classes.paginationBtn}
      >
        Previous
      </button>
    );

    // Page numbers
    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={`${classes.paginationBtn} ${currentPage === i ? classes.activePage : ''}`}
        >
          {i}
        </button>
      );
    }

    // Next button
    buttons.push(
      <button
        key="next"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={classes.paginationBtn}
      >
        Next
      </button>
    );

    return buttons;
  };

  return (
    <div style={{ backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
      <HeaderNav />

      <div className={classes.topContainer}>
        <div className={classes.backTxt} onClick={() => navigate(-1)}>
          <img src={BackLogo} alt="back" className={classes.iconBtn} />
          <div className={classes.bckText}>
            <h3 className={classes.topText}>Province Status Report</h3>
          </div>
        </div>

        <div style={{ marginTop: 12 }} />
        <div className={classes.topNavBars}>
          <div className={classes.filterRow}>
            {/* Left side: Inputs */}
            <div className={classes.filterInputs}>
              {/* Continent Filter */}
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Continent:</label>
                <Select
                  value={continents.find(c => c.value === selectedContinent) || null}
                  onChange={handleContinentChange}
                  options={continents}
                  isClearable
                  placeholder="Select Continent"
                  menuPortalTarget={document.body}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: 200,
                      fontSize: 12,
                    }),
                    control: (provided) => ({
                      ...provided,
                      minHeight: "36px",
                      fontSize: 12,
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      fontSize: 12,
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      fontSize: 12,
                      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                      color: "#111827",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: "300px",
                      maxWidth: "200px",
                      overflowY: "auto",
                      fontSize: 12,
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  className={classes.inlineSelect}
                />
              </div>

              {/* Region Filter */}
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Region:</label>
                <Select
                  value={regions.find(r => r.value === selectedRegion) || null}
                  onChange={handleRegionChange}
                  options={regions}
                  isClearable
                  placeholder="Select Region"
                  isDisabled={!selectedContinent}
                  menuPortalTarget={document.body}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: 200,
                      fontSize: 12,
                    }),
                    control: (provided) => ({
                      ...provided,
                      minHeight: "36px",
                      fontSize: 12,
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      fontSize: 12,
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      fontSize: 12,
                      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                      color: "#111827",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: "300px",
                      maxWidth: "200px",
                      overflowY: "auto",
                      fontSize: 12,
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  className={classes.inlineSelect}
                />
              </div>
            </div>
          </div>
        </div>

        <div style={{ marginTop: 24 }} />

        <div className={classes.tableContainer}>
          {loading ? (
            <div className={classes.overlay}>
              <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
            </div>
          ) : provinces.length === 0 ? (
            <div style={{
              textAlign: "center",
              padding: "40px",
              fontSize: "18px",
              color: "#374151",
            }}>
              <p>No provinces data to display</p>
            </div>
          ) : (
            <>
              <div className={classes.sideTools}>
                <div className={classes.filterIcons}>
                  <img
                    src={MailLogo}
                    alt="Mail"
                    className={classes.iconBtns}
                    onClick={() => console.log("Mail clicked")}
                  />
                  <img
                    onClick={handlePrint}
                    src={PrintLogo}
                    alt="Print"
                    className={classes.iconBtns}
                  />
                  <img
                    // onClick={exportToExcel}
                    onClick={ExcelDownload}
                    src={ExcelLogo}
                    alt="Excel"
                    className={classes.iconBtns}
                  />
                  <img
                    onClick={exportToPDF}
                    src={PdfLogo}
                    alt="PDF"
                    className={classes.iconBtns}
                  />
                </div>
              </div>

              <div className={classes.cntrTable}>
                <h1 className={classes.cntrTxt}>
                  The Redeemed Christian Church Of God
                </h1>
                <p className={classes.cntrTxt12}>Province Status Report</p>
                <p className={classes.cntrTx122}>
                  {selectedContinent || selectedRegion
                    ? "Filtered Province Status"
                    : "All Provinces Status"}
                </p>
              </div>

              {/* Province Status Table */}
              <table style={{
                width: "100%",
                borderCollapse: "collapse",
                marginTop: 20,
                backgroundColor: "white",
                borderRadius: "8px",
                overflow: "hidden",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
              }}>
                <thead>
                  <tr style={{
                    backgroundColor: "#f8fafc",
                    borderBottom: "2px solid #e2e8f0"
                  }}>
                    <th style={{
                      padding: "12px",
                      textAlign: "left",
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#374151",
                      width: "60px"
                    }}>
                      S/N
                    </th>
                    <th style={{
                      padding: "12px",
                      textAlign: "left",
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#374151"
                    }}>
                      PROVINCE
                    </th>
                    <th style={{
                      padding: "12px",
                      textAlign: "left",
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#374151"
                    }}>
                      REGION
                    </th>
                    <th style={{
                      padding: "12px",
                      textAlign: "left",
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#374151"
                    }}>
                      CONTINENT
                    </th>
                    <th style={{
                      padding: "12px",
                      textAlign: "left",
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#374151"
                    }}>
                      LAST DATE
                    </th>
                    <th style={{
                      padding: "12px",
                      textAlign: "left",
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#374151"
                    }}>
                      STATUS
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {provinces.map((province, index) => (
                    <tr
                      key={province.id || index}
                      style={{
                        borderBottom: "1px solid #e2e8f0",
                        backgroundColor: index % 2 === 0 ? "#ffffff" : "#f8fafc"
                      }}
                    >
                      <td style={{
                        padding: "12px",
                        fontSize: "14px",
                        color: "#6b7280",
                        fontWeight: "500"
                      }}>
                        {getSerialNumber(index)}
                      </td>
                      <td style={{
                        padding: "12px",
                        fontSize: "14px",
                        color: "#1f2937",
                        fontWeight: "500",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "200px"
                      }}>
                        {(province.description || province.name || 'N/A')}
                      </td>
                      <td style={{
                        padding: "12px",
                        fontSize: "14px",
                        color: "#1f2937",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "150px"
                      }}>
                        {formatTextWithEllipsis(province.region?.description || 'N/A')}
                      </td>
                      <td style={{
                        padding: "12px",
                        fontSize: "14px",
                        color: "#1f2937",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "150px"
                      }}>
                        {formatTextWithEllipsis(province.continent?.description || 'N/A')}
                      </td>
                      <td style={{
                        padding: "12px",
                        fontSize: "14px",
                        color: "#6b7280"
                      }}>
                        {formatDate(province.last_date)}
                      </td>
                      <td style={{
                        padding: "12px",
                        fontSize: "14px",
                        color: "#1f2937"
                      }}>
                        <Badge bg={
                          province.status === 1 ? "success" :
                            province.status === 2 ? "warning" : "danger"
                        }>
                          {
                            province.status === 1 ? "Updated" :
                              province.status === 2 ? "Behind Schedule" : "Outdated"
                          }
                        </Badge>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className={classes.paginationContainer}>
                  {renderPaginationButtons()}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProvinceStatus;